import type EditorScenarios from '../store/schema/EditorScenarios';

export function getEditorScenarioFromEditorId(editorId: string): EditorScenarios | undefined {
    const [scenario] = editorId.split('_');
    const scenarioId = parseInt(scenario);
    return !isNaN(scenarioId) ? scenarioId : undefined;
}
